import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import type { ItemMadeBy } from "../../../api/content/authoring/processAuthoringApi";
import { appPaths } from "../../../shared/routing/appPaths";
import ItemReferenceName from "../ItemReferenceName";

/** "Merged in change set …; made by Workflow … in Thread …, entry 7", or "by hand". */
export default function MadeByText({ madeBy }: { madeBy: ItemMadeBy | null }) {
  const { t } = useTranslation();
  if (madeBy === null) {
    return <p className="app-text-muted text-sm">{t("authoring.artifactPage.noMerge")}</p>;
  }
  return (
    <p className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm">
      <Link to={appPaths.review(madeBy.changeSetId)} className="app-link underline">{t("authoring.artifactPage.changeSet")}</Link>
      {madeBy.workflow === null ? (
        <span className="app-text-muted">{t("authoring.artifactPage.byPerson")}</span>
      ) : (
        <span>
          {t("authoring.artifactPage.byWorkflow")} <Link to={appPaths.workflow(madeBy.workflow)} className="app-link underline"><ItemReferenceName reference={madeBy.workflow} link={false} /></Link>
        </span>
      )}
      {madeBy.originEntries.map((origin) => {
        const [threadId = "", entry = ""] = origin.split("#");
        return (
          <Link key={origin} to={appPaths.thread(threadId, Number(entry) || null)} className="app-link underline">
            {t("authoring.artifactPage.threadEntry", { entry })}
          </Link>
        );
      })}
      {madeBy.originEntries.length === 0 && madeBy.thread !== null ? <Link to={appPaths.thread(madeBy.thread)} className="app-link underline">{t("authoring.artifactPage.thread")}</Link> : null}
    </p>
  );
}
